import React, { useContext, useEffect } from "react";

import { get } from 'lodash';
import cx from "classnames";
import useMeasure from "react-use-measure";

import Cropper, { ReactCropperElement } from "react-cropper";
import {animated, useTransition } from "@react-spring/web";

import "cropperjs/dist/cropper.css";
import styles from "./crop.module.scss";
import { MenuState } from "src/types/settings/accountManagement";

interface CropEditorProps {
  children?: React.ReactNode;
  enabled: boolean;
  entity: any;
  menuState: MenuState;
  // eslint-disable-next-line no-unused-vars
  onMenuChange: (value: MenuState) => void;
  onChange: (field: string, value: any) => void;
}

const CropEditor: React.FC<CropEditorProps> = ({ enabled, entity, menuState, onMenuChange,onChange }) => {

  const [editorRef, editorBounds] = useMeasure();
  const cropperRef = React.useRef<ReactCropperElement>(null);

  const [crop, setCrop] = React.useState<{ x: number, y: number, width: number; height: number } | null>(get(entity, 'banner.crop') || null);
  const [initialized, setInitialized] = React.useState(false);

  const banner = get(entity, 'banner.background.full');

  const editorTransitions = useTransition(initialized, {
    initial: { opacity: 0 },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: {
      duration: 800,
      friction: 14,
      tension: 120,
    },
  });

  useEffect(() => {
    if (enabled && editorBounds.height > 0) {
      setInitialized(true);
    }
  }, [editorBounds, enabled]);

  useEffect(() => {
    if (menuState.secondaryAction === 'apply-crop') {
      const cropper = cropperRef.current!.cropper;
      const croppedCanvas = cropper.getCroppedCanvas();
  
      const croppedImage = croppedCanvas.toDataURL();
  
      const updatedBanner = {
        ...entity.banner,
        background: {
          ...entity.banner.background,
          full: croppedImage,
        },
        crop: cropper.getData(),
      };
  
      onChange("banner", updatedBanner);
  
      onMenuChange({
        ...menuState,
        secondaryAction: null,
      });
    }
  }, [menuState]);
  

  return (
    <div ref={editorRef} className={cx(styles.editor, { [styles.enabled]: enabled })}>
      {editorTransitions((style, item) => (
        item && <animated.div className={styles.cropper} style={style}>
          <Cropper ref={cropperRef} src={banner} style={{
            maxWidth: '100%',
            maxHeight: '100%',
          }}
            zoomable={false}
            viewMode={1}
            guides={false}
            minContainerHeight={editorBounds.height}
            ready={() => {
              if (crop) {
                cropperRef.current!.cropper.setData(crop!);
              }
            }}
            data={crop ? {
              x: crop?.x || 0,
              y: crop?.y || 0,
              width: crop?.width || 100,
              height: crop?.height || 100,
            } : undefined}
            autoCrop={true}
            autoCropArea={1}
            crop={(e) => {
              setCrop(e.detail);
            }}
          />
        </animated.div>
      ))}
    </div>
  );
}

export { CropEditor };